import type React from "react";

export const SelectionVerbiageNew: React.FC<{
  minSelection: number | null;
  maxSelection: number | null;
  currentCount: number;
}> = ({ minSelection, maxSelection, currentCount }) => {
  if (minSelection === null && maxSelection === null) {
    return null;
  }

  let text: string | null = null;
  if (minSelection === null && maxSelection !== null) {
    text = `Select up to ${maxSelection}`;
  } else if (minSelection !== null && maxSelection === null) {
    text = `Select at least ${minSelection}`;
  } else if (minSelection !== null && maxSelection !== null) {
    if (minSelection === maxSelection) {
      text = `Select ${minSelection}`;
    } else if (maxSelection - minSelection === 1) {
      text = `Select ${minSelection} or ${maxSelection}`;
    } else {
      text = `Select between ${minSelection} and ${maxSelection}`;
    }
  }

  // How many more are needed to meet the minimum
  const needed = Math.max(0, (minSelection ?? 0) - currentCount);

  return (
    <div className="flex items-center gap-2 mt-0.5">
      {text && <span className="text-xs font-medium text-gray-500">{text}</span>}
      <span
        className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold transition-opacity duration-200 ${
          needed > 0 ? "bg-amber-100 text-amber-700 opacity-100" : "opacity-0"
        }`}
      >
        {needed > 0 ? `${needed} ${needed === 1 ? "selection" : "selections"} needed` : "\u00A0"}
      </span>
    </div>
  );
};
